<script setup lang="ts">
import type { JSONDataType } from 'vue-json-pretty/types/utils'

const { RemoteConfigurationStore, LocalConfigurationStore } = stores()
const { visible } = useVisible()
const selectedConfiguration = ref<'remote' | 'local'>('remote')
const selectedRemoteConfiguration = ref<keyof RemoteConfigurations>('producto')
const selectedLocalConfiguration = ref<keyof LocalConfigurations>('brokerContext')
const remoteConfigurationOptions: (keyof RemoteConfigurations)[] = [
  'producto',
  'broker',
  'emisor',
  'subRamo',
  'form',
  'brokerProductos',
]

const remoteConfigurationProps: ComputedRef<object> = computed(() => ({
  initBy: RemoteConfigurationStore.value?.initBy,
  tipoUsuario: RemoteConfigurationStore.value?.tipoUsuario,
  ramo: RemoteConfigurationStore.value?.ramo,
  ramoEnum: RemoteConfigurationStore.value?.ramoEnum,
  brokerProductoId: RemoteConfigurationStore.value?.brokerProductoId,
  tipoAgrupacion: RemoteConfigurationStore.value?.tipoAgrupacion,
}))

const currentConfiguration = computed(() => {
  switch (selectedConfiguration.value) {
    case 'remote':
      if (selectedRemoteConfiguration.value)
        return RemoteConfigurationStore.value?.[selectedRemoteConfiguration.value]
      break
    case 'local':
      if (selectedLocalConfiguration.value)
        return LocalConfigurationStore.value?.[selectedLocalConfiguration.value]
      break
  }
  return null
})
</script>
<template>
  <PvButton
    class="flex items-center gap-2 leading-none"
    @click="visible = !visible"
  >
    <span class="icon-[ph--code-block] text-xl" />
    <span class="font-bold">STORES</span>
  </PvButton>
  <PvDialog
    v-model:visible="visible"
    class="w-[90%] max-w-[90%] md:w-[75rem]"
    :closable="false"
  >
    <div class="flex justify-between p-8">
      <TitleComponent
        text="Stores"
        no-caps
        type="subtitle"
        icon-class="icon-[ph--code-block]"
      />
      <div class="flex gap-2">
        <PvButton
          :severity="selectedConfiguration === 'remote' ? 'primary' : 'secondary'"
          :outlined="selectedConfiguration !== 'remote'"
          @click="selectedConfiguration = 'remote'"
        >
          remote
        </PvButton>
        <PvButton
          :severity="selectedConfiguration === 'local' ? 'primary' : 'secondary'"
          :outlined="selectedConfiguration !== 'local'"
          @click="selectedConfiguration = 'local'"
        >
          local
        </PvButton>
        <PvButton
          severity="contrast"
          @click="visible = !visible"
        >
          <span class="icon-[ph--x-circle] text-xl" />
        </PvButton>
      </div>
    </div>
    <PvDivider />
    <div class="grid gap-4 p-8">
      <div class="flex flex-wrap gap-2">
        <template v-if="selectedConfiguration === 'remote'">
          <template
            v-for="key in remoteConfigurationOptions"
            :key="key"
          >
            <PvButton
              :severity="selectedRemoteConfiguration === key ? 'primary' : 'secondary'"
              :outlined="selectedRemoteConfiguration !== key"
              @click="selectedRemoteConfiguration = key"
            >
              {{ key }}
            </PvButton>
          </template>
        </template>
        <template v-if="selectedConfiguration === 'local'">
          <template
            v-for="(_, key) in LocalConfigurationStore"
            :key="key"
          >
            <PvButton
              :severity="selectedLocalConfiguration === key ? 'primary' : 'secondary'"
              :outlined="selectedLocalConfiguration !== key"
              @click="selectedLocalConfiguration = key"
            >
              {{ key }}
            </PvButton>
          </template>
        </template>
      </div>
      <JsonViewerComponent
        v-if="selectedConfiguration === 'remote'"
        :value="remoteConfigurationProps as JSONDataType"
      />
      <JsonViewerComponent
        v-if="selectedLocalConfiguration && currentConfiguration"
        :value="currentConfiguration as JSONDataType"
      />
    </div>
  </PvDialog>
</template>
